import { Component, OnInit, ErrorHandler } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationService } from '../../../registration.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-military-operation-form',
  templateUrl: './military-operation-form.component.html',
  styleUrls: ['./military-operation-form.component.css']
})
export class MilitaryOperationFormComponent implements OnInit {

  maintitle="Military Operations";
  title = "Add Military Operations";
  m:any={};
  formSubmitted: boolean;
  mode: string = "save";
  Mil_OperationId: string;
  formInvalid: boolean = false;
  data: any={};
  constructor(private route: ActivatedRoute,private router: Router,private errorHandler:ErrorHandler,private userService: RegistrationService) { }


  ngOnInit() {


    //From URL
  this.mode=localStorage.getItem('mode');
  this.Mil_OperationId= localStorage.getItem('Mil_OperationId');
  localStorage.removeItem('Mil_OperationId'); 
  localStorage.removeItem('mode');
  
  if (this.Mil_OperationId != null && this.mode!=null) 
    this.GetOperationsById(this.Mil_OperationId);
  }



 
//For Year Dropdown
  onOpenCalendar(datepicker) {
    datepicker.yearSelectHandler = (event: any): void => {
      datepicker._store.dispatch(datepicker._actions.select(event.date));
    };     
    datepicker.setViewMode('year');
  }

  ngAfterViewInit(){
    var year = 1900;
    var till = 2050;
    var options = "";
    for(var y=year; y<=till; y++){
      options += "<option>"+ y +"</option>";
    }
    document.getElementById("year").innerHTML = options;
  }

  // SaveMilitaryOperations(MO: NgForm) {
  //   if (!MO.invalid) {
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.userService.saveMilitaryOperations(MO.value)
  //     .subscribe(
  //       (data) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //         swal('','Saved Successfully!','success');
  //         this.router.navigate(['/home/MilitaryOperations']);
  //       }, (error) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //         this.errorHandler.handleError(error);
  //         swal('Warning!', error.error.Message, 'warning');
  //       });
  //     }else{          
  //     document.getElementById('loader-spinner').style.display = "none";
  //     this.formSubmitted = true;
  //     }
  // }


  SaveMilitaryOperations(MO: NgForm) {    
    
       if (!MO.invalid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.saveMilitaryOperations(MO.value);
      this.data.subscribe(
        (response) => {
          MO.reset();
          MO.resetForm();       
           swal('Success!', 'Military Operations saved Successfully .', 'success');
           this.router.navigate(['/home/MilitaryOperations']);   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }


  GetOperationsById(Mil_OperationId) {
    document.getElementById('loader-spinner').style.display = "block";
   this.userService.getOperationsById(Mil_OperationId)
   .subscribe(
     (data) => {
       this.m = data;
       document.getElementById('loader-spinner').style.display = "none";
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       this.errorHandler.handleError(error);
     });
}


UpdateMilitaryOperations(Mo: NgForm) {
  if (!Mo.invalid) {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.updateMilitaryOperations(Mo.value,this.Mil_OperationId)
    .subscribe(
      (data) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Updated Successfully!','success');
        this.router.navigate(['/home/MilitaryOperations']); 
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
        //swal('Warning!', error.error.Message, 'warning');
      });
    }else{
      document.getElementById('loader-spinner').style.display = "none";
      swal('warning','Please fill all the mandatory fields!','warning');
      this.formSubmitted = true;

      }
}


Reset(MO)
{    
  MO.reset();
}



  
}



// WEBPACK FOOTER //
// ./src/app/Masters/military-operations/military-operation-form/military-operation-form.component.ts